/* eslint-disable import/prefer-default-export */
import {
  TravelAnalysisMessages,
  TranslationTravelAnalysisMessages
} from "../interfaces";

export const messages: TranslationTravelAnalysisMessages = {
  [TravelAnalysisMessages.pageTitle]: "Análisis de Viajes",
  [TravelAnalysisMessages.filterButton]: "Filtrar",
  [TravelAnalysisMessages.loading]: "Cargando...",
  [TravelAnalysisMessages.totalAnalyzed]: "Total Analizado",
  [TravelAnalysisMessages.successfulTrips]: "Viajes Exitosos",
  [TravelAnalysisMessages.successRate]: "Tasa de Éxito",
  [TravelAnalysisMessages.alertsDetected]: "Alertas Detectadas",
  [TravelAnalysisMessages.target]: "META",
  [TravelAnalysisMessages.alertDistributionTitle]: "Distribución de Alertas por Tipo",
  [TravelAnalysisMessages.noAlertsInPeriod]: "Sin alertas en el período",
  [TravelAnalysisMessages.successRatioTitle]: "Proporción Éxito vs Alertas",
  [TravelAnalysisMessages.noData]: "Sin datos",
  [TravelAnalysisMessages.success]: "Éxito",
  [TravelAnalysisMessages.alerts]: "Alertas",
  [TravelAnalysisMessages.efficiency]: "Eficiencia",
  [TravelAnalysisMessages.geographicMonitoringTitle]: "Monitoreo Geográfico",
  [TravelAnalysisMessages.geographicMonitoringSubtitle]: "Distribución de alertas por región de operación",
  [TravelAnalysisMessages.noGeographicData]: "Sin datos geográficos",
  [TravelAnalysisMessages.activeVehicles]: "Vehículos Activos",
  [TravelAnalysisMessages.activeAlerts]: "Alertas Activas",
  [TravelAnalysisMessages.dashboardSubtitle]: "DASHBOARD DE OPERACIONES",
  [TravelAnalysisMessages.percentOfTotal]: "del total",
  [TravelAnalysisMessages.alertsListTitle]: "Detalle de Alertas",
  [TravelAnalysisMessages.columnVehicle]: "Vehículo",
  [TravelAnalysisMessages.columnAlertType]: "Tipo de Alerta",
  [TravelAnalysisMessages.columnOrigin]: "Origen",
  [TravelAnalysisMessages.columnDestination]: "Destino",
  [TravelAnalysisMessages.columnDate]: "Fecha",
  [TravelAnalysisMessages.noAlertsFound]: "No se encontraron alertas",
  [TravelAnalysisMessages.loadMore]: "Cargar más",
  [TravelAnalysisMessages.close]: "Cerrar",
  [TravelAnalysisMessages.tripsUnit]: "viajes",
  [TravelAnalysisMessages.columnNumDoc]: "Nº Doc",
  [TravelAnalysisMessages.columnActions]: "Acciones",
  [TravelAnalysisMessages.viewAlertDetails]: "Detalles de la alerta",
  [TravelAnalysisMessages.viewTravel]: "Abrir viaje",
  [TravelAnalysisMessages.alertDetailsTitle]: "Detalles del Análisis",
  [TravelAnalysisMessages.loadingTravel]: "Cargando viaje...",
  // Metadata labels — CAN Data Stall
  [TravelAnalysisMessages.metaSource]: "Fuente de datos",
  [TravelAnalysisMessages.metaStallType]: "Tipo de estancamiento",
  [TravelAnalysisMessages.metaThreshold]: "Umbral",
  [TravelAnalysisMessages.metaStalledFields]: "Campos estancados",
  [TravelAnalysisMessages.metaTotalCanPackets]: "Total de paquetes CAN",
  // Cross Day Cycle
  [TravelAnalysisMessages.metaStartDate]: "Fecha de inicio",
  [TravelAnalysisMessages.metaFinishDate]: "Fecha de fin",
  [TravelAnalysisMessages.metaStartDay]: "Día de inicio",
  [TravelAnalysisMessages.metaFinishDay]: "Día de fin",
  [TravelAnalysisMessages.metaDurationHours]: "Duración (horas)",
  // False Positive Discharge
  [TravelAnalysisMessages.metaTotalDischargeCommands]: "Total de comandos de descarga",
  [TravelAnalysisMessages.metaCoveredCommands]: "Comandos cubiertos",
  [TravelAnalysisMessages.metaOrphanCommands]: "Comandos huérfanos",
  [TravelAnalysisMessages.metaOrphanRatio]: "Tasa de huérfanos (%)",
  [TravelAnalysisMessages.metaCoveredRanges]: "Períodos cubiertos",
  // GPRS Connection Instability
  [TravelAnalysisMessages.metaTotalPackets]: "Total de paquetes",
  [TravelAnalysisMessages.metaMemoryCommands]: "Comandos offline real",
  [TravelAnalysisMessages.metaEffectiveRealtimeCommands]: "Comandos efectivamente tiempo real",
  [TravelAnalysisMessages.metaRealtimeCommands]: "Comandos en tiempo real",
  [TravelAnalysisMessages.metaMemoryRatio]: "Tasa de offline real (%)",
  [TravelAnalysisMessages.metaThresholdPercent]: "Umbral (%)",
  [TravelAnalysisMessages.metaEffectiveRealtimeThresholdSeconds]: "Umbral de tiempo real efectivo (s)",
  [TravelAnalysisMessages.metaAvgDelaySeconds]: "Promedio de delay de transmisión (s)",
  [TravelAnalysisMessages.metaMaxDelaySeconds]: "Mayor delay de transmisión (s)",
  // GPS Positioning Failure
  [TravelAnalysisMessages.metaTotalGpsPackets]: "Total de paquetes GPS",
  [TravelAnalysisMessages.metaInvalidFixCount]: "Posiciones inválidas",
  [TravelAnalysisMessages.metaInvalidRatio]: "Tasa de inválidos (%)",
  [TravelAnalysisMessages.metaAvgSatellites]: "Promedio de satélites",
  // Hardware Command Deficit
  [TravelAnalysisMessages.metaPacketCount]: "Paquetes recibidos",
  [TravelAnalysisMessages.metaExpectedPackets]: "Paquetes esperados",
  [TravelAnalysisMessages.metaMinimumRequired]: "Mínimo requerido",
  [TravelAnalysisMessages.metaDeficitPercent]: "Déficit (%)",
  [TravelAnalysisMessages.metaRatePerMinute]: "Tasa por minuto",
  [TravelAnalysisMessages.metaTravelDurationMinutes]: "Duración del viaje (min)",
  // Logistics Flow Inconsistency
  [TravelAnalysisMessages.metaRequiredStates]: "Estados obligatorios",
  [TravelAnalysisMessages.metaActualStates]: "Estados presentes",
  [TravelAnalysisMessages.metaMissingStates]: "Estados ausentes",
  [TravelAnalysisMessages.metaMissingCount]: "Cantidad faltante",
  [TravelAnalysisMessages.metaTotalStates]: "Total de estados",
  [TravelAnalysisMessages.metaNumDoc]: "Nº documento",
  // Sensor Command Deficit (IDLE)
  [TravelAnalysisMessages.metaIgnitionOnCount]: "Comandos con ignición ON",
  [TravelAnalysisMessages.metaIdleCount]: "Comandos en IDLE",
  [TravelAnalysisMessages.metaLoadingCount]: "Comandos cargando",
  [TravelAnalysisMessages.metaUnloadingCount]: "Comandos descargando",
  [TravelAnalysisMessages.metaIdleRatio]: "Tasa de IDLE (%)",
  [TravelAnalysisMessages.successByDayTitle]: "Éxito por Día",
  [TravelAnalysisMessages.successByPlantTitle]: "Éxito por Central",
  [TravelAnalysisMessages.successByRegionalTitle]: "Éxito por Regional",
  [TravelAnalysisMessages.averageLine]: "Promedio",
  [TravelAnalysisMessages.noGroupedData]: "Sin datos para el período seleccionado",
  [TravelAnalysisMessages.coordinateViewTitle]: "Visualización de Coordenadas",
  [TravelAnalysisMessages.coordinateViewVehicle]: "Vehículo",
  [TravelAnalysisMessages.coordinateViewNF]: "NF",
  [TravelAnalysisMessages.coordinateViewGeneral]: "General",
  [TravelAnalysisMessages.coordinateViewContent]: "Contenido",
  [TravelAnalysisMessages.coordinateViewResult]: "Resultado",
  [TravelAnalysisMessages.coordinateViewGeneralData]: "Datos Generales",
  [TravelAnalysisMessages.coordinateViewCommandContent]: "Contenido del Comando",
  [TravelAnalysisMessages.coordinateViewProcessingResult]: "Resultado del Procesamiento",
  [TravelAnalysisMessages.coordinateViewNoData]: "Sin datos",
  [TravelAnalysisMessages.coordinateViewField]: "Campo",
  [TravelAnalysisMessages.coordinateViewValue]: "Valor",
  // Alert glossary (help drawer)
  [TravelAnalysisMessages.glossaryButtonLabel]:
    "Sobre el análisis",
  [TravelAnalysisMessages.glossaryDrawerTitle]:
    "Entienda el Análisis de Viajes",
  [TravelAnalysisMessages.glossaryIntroTitle]: "Cómo funciona el análisis",
  [TravelAnalysisMessages.glossaryIntroText]:
    "El viaje con nota tiene ciclo completo cuando registra los 5 estados (En camino, En obra, Descargando, Retornando y En planta) y, si el cliente usa integración, los envía todos. Cada viaje con falla recibe una única causa: la que explica el primer estado que faltó. La clasificación se ejecuta sola cuando el viaje termina o se cancela. Las alertas de telemetría, más abajo, avisan sobre la calidad de los datos y no cuentan en el ciclo completo.",
  [TravelAnalysisMessages.glossaryWhenLabel]: "Cuándo se dispara",
  [TravelAnalysisMessages.glossaryAppliesLabel]: "Se aplica a",
  [TravelAnalysisMessages.glossaryMetadataLabel]: "Detalles capturados (metadatos)",
  [TravelAnalysisMessages.glossaryAppliesAll]: "Todos los vehículos",
  [TravelAnalysisMessages.glossaryAppliesMixerPump]: "Hormigoneras y camiones bomba",
  [TravelAnalysisMessages.glossaryAppliesMixer]: "Hormigoneras",
  [TravelAnalysisMessages.glossaryAppliesMixerDoc]: "Hormigoneras con Nº de documento (viaje de hormigón)",
  // Glossary — GPRS Connection Instability
  [TravelAnalysisMessages.glossaryGprsTitle]: "Inestabilidad de conexión GPRS",
  [TravelAnalysisMessages.glossaryGprsDesc]:
    "Indica que el rastreador perdió la señal de datos (GPRS) durante el viaje. Los paquetes capturados sin conexión quedan guardados en la memoria del equipo y solo llegan al servidor cuando la señal vuelve, con retraso. Un volumen alto de estos paquetes atrasados sugiere mala cobertura o un problema de operadora/SIM, y puede dejar tramos sin rastro en el trayecto.",
  [TravelAnalysisMessages.glossaryGprsWhen]:
    "Cuando el 30% o más de los paquetes llegaron atrasados desde la memoria (retraso de transmisión de 60s o más). Los paquetes de memoria que llegan en menos de 60s se tratan como tiempo real y no cuentan.",
  [TravelAnalysisMessages.glossaryGprsMeta]:
    "Los números muestran cuántos paquetes llegaron en tiempo real, cuántos llegaron realmente atrasados desde la memoria y el retraso medio y máximo de transmisión — cuanto mayor el retraso, peor estaba la señal.",
  // Glossary — GPS Positioning Failure
  [TravelAnalysisMessages.glossaryGpsTitle]: "Falla de posicionamiento GPS",
  [TravelAnalysisMessages.glossaryGpsDesc]:
    "Indica que el equipo no logró obtener una posición confiable de satélite en buena parte del viaje. Puede ocurrir por obstrucción (túneles, áreas cerradas), problema en la antena o pocos satélites visibles, afectando la precisión del trayecto registrado.",
  [TravelAnalysisMessages.glossaryGpsWhen]:
    "Cuando el 30% o más de los paquetes con datos de GPS no tenían fijación válida de satélite (FIX inválido).",
  [TravelAnalysisMessages.glossaryGpsMeta]:
    "Muestran el total de paquetes GPS, cuántos estaban sin fijación y el promedio de satélites captados — promedios bajos refuerzan la dificultad de recepción.",
  // Glossary — Cross Day Cycle
  [TravelAnalysisMessages.glossaryCrossDayTitle]: "Ciclo transversal (D+1)",
  [TravelAnalysisMessages.glossaryCrossDayDesc]:
    "Señala viajes que comenzaron en un día y solo terminaron al día siguiente. Ese 'cambio de día' impacta el cierre de productividad diaria, ya que el viaje aparece en dos días diferentes.",
  [TravelAnalysisMessages.glossaryCrossDayWhen]:
    "Cuando el día de inicio es diferente del día de fin y el viaje duró 6 horas o más (los viajes cortos que solo cruzan la medianoche se ignoran).",
  [TravelAnalysisMessages.glossaryCrossDayMeta]:
    "Muestran las fechas y los días de inicio y fin, además de la duración total del viaje en horas.",
  // Glossary — Hardware Command Deficit
  [TravelAnalysisMessages.glossaryHwDeficitTitle]: "Déficit de comandos de hardware enviados",
  [TravelAnalysisMessages.glossaryHwDeficitDesc]:
    "Indica que el rastreador transmitió menos paquetes de los esperados para la duración del viaje. Puede señalar un equipo con falla, apagado parte del tiempo o con problema de transmisión, reduciendo la confiabilidad de los datos del viaje.",
  [TravelAnalysisMessages.glossaryHwDeficitWhen]:
    "Cuando el número de paquetes recibidos quedó por debajo del 50% de lo esperado (referencia de 1 paquete cada 2 minutos). Evaluado solo en viajes de más de 5 minutos.",
  [TravelAnalysisMessages.glossaryHwDeficitMeta]:
    "Comparan los paquetes recibidos con los esperados y muestran el déficit porcentual y la tasa de paquetes por minuto.",
  // Glossary — Sensor Command Deficit (IDLE)
  [TravelAnalysisMessages.glossarySensorIdleTitle]: "Déficit de comandos de sensor activo (IDLE elevado)",
  [TravelAnalysisMessages.glossarySensorIdleDesc]:
    "Indica que, con el vehículo encendido, el tambor quedó detenido — sin cargar ni descargar — durante buena parte del viaje. Puede señalar un sensor del tambor con falla o un problema de comunicación, perjudicando la lectura de las etapas de carga y descarga.",
  [TravelAnalysisMessages.glossarySensorIdleWhen]:
    "Cuando, entre los paquetes con ignición encendida, el 50% o más tenían el tambor detenido (IDLE). Evaluado con al menos 10 paquetes de ignición encendida.",
  [TravelAnalysisMessages.glossarySensorIdleMeta]:
    "Muestran cuántos paquetes tenían ignición encendida y, de esos, cuántos estaban cargando, descargando o detenidos (IDLE).",
  // Glossary — Logistics Flow Inconsistency
  [TravelAnalysisMessages.glossaryLogisticsTitle]: "Inconsistencia de flujo logístico",
  [TravelAnalysisMessages.glossaryLogisticsDesc]:
    "Señala viajes de hormigón que no pasaron por todos los estados esperados del ciclo (En la planta → En camino → En obra → Descargando → Regresando). La ausencia de un estado puede indicar falla de detección, trayecto atípico o un problema en el registro del viaje.",
  [TravelAnalysisMessages.glossaryLogisticsWhen]:
    "Cuando falta al menos uno de los estados obligatorios. Verifica la presencia de cada estado, no el orden.",
  [TravelAnalysisMessages.glossaryLogisticsMeta]:
    "Listan los estados obligatorios, los que ocurrieron y los que faltaron en el viaje.",
  // Glossary — CAN Data Stall
  [TravelAnalysisMessages.glossaryCanStallTitle]: "Información de CAN estancada (completa o parcial)",
  [TravelAnalysisMessages.glossaryCanStallDesc]:
    "Indica que datos provenientes del bus CAN del vehículo (velocidad, RPM, combustible, odómetro) quedaron 'congelados', repitiendo el mismo valor en varios paquetes seguidos. Suele señalar una falla en la lectura del CAN, perjudicando la telemetría del vehículo.",
  [TravelAnalysisMessages.glossaryCanStallWhen]:
    "Cuando algún campo del CAN repite el mismo valor en 10 paquetes consecutivos o más. 'Total' = todos los campos congelados; 'Parcial' = al menos un campo congelado.",
  [TravelAnalysisMessages.glossaryCanStallMeta]:
    "Muestran qué campos se estancaron, durante cuántos paquetes seguidos y el valor que quedó repetido.",
  // Glossary — False Positive Discharge
  [TravelAnalysisMessages.glossaryFalseDischargeTitle]: "Falsos positivos de descarga",
  [TravelAnalysisMessages.glossaryFalseDischargeDesc]:
    "Señala comandos de descarga del tambor que ocurrieron fuera de cualquier contexto válido de descarga (sin estar descargando, en la planta, en un lugar confiable o en un evento de descarga indebida). Estos comandos 'huérfanos' pueden ser ruido de sensor o descargas no detectadas correctamente.",
  [TravelAnalysisMessages.glossaryFalseDischargeWhen]:
    "Cuando hay 3 o más comandos de descarga huérfanos (no cubiertos por ningún período de descarga conocido).",
  [TravelAnalysisMessages.glossaryFalseDischargeMeta]:
    "Muestran el total de comandos de descarga, cuántos estaban cubiertos por un contexto válido y cuántos quedaron huérfanos.",
  // Travel cycle analysis
  [TravelAnalysisMessages.cycleKpiTicketTravels]: "viajes con nota",
  [TravelAnalysisMessages.cycleKpiComplete]: "Ciclo completo",
  [TravelAnalysisMessages.cycleKpiCompleteSub]: "viajes con los 5 estados",
  [TravelAnalysisMessages.cycleKpiFailed]: "Viajes con falla",
  [TravelAnalysisMessages.cycleKpiSeeCauses]: "ver causas",
  [TravelAnalysisMessages.cycleKpiHardware]: "Hardware a revisar",
  [TravelAnalysisMessages.cycleKpiSensors]: "sensores de descarga",
  [TravelAnalysisMessages.cycleKpiTrackers]: "rastreadores",
  [TravelAnalysisMessages.cycleKpiVehicles]: "vehículos",
  [TravelAnalysisMessages.cycleImpactTitle]: "Dónde están las fallas",
  [TravelAnalysisMessages.cycleImpactHint]: "Cada viaje con falla recibe una única causa. Haga clic en la causa para ver los vehículos y, en cada vehículo, los viajes.",
  [TravelAnalysisMessages.cycleNoFailures]: "Sin fallas en el período.",
  [TravelAnalysisMessages.groupEquipment]: "Equipo del camión",
  [TravelAnalysisMessages.groupEquipmentDesc]: "El sensor de descarga o el rastreador no registró lo que ocurrió en el viaje.",
  [TravelAnalysisMessages.groupRegistration]: "Registro de planta y obra",
  [TravelAnalysisMessages.groupRegistrationDesc]: "La ubicación registrada de la planta o de la obra no coincide con donde opera el camión.",
  [TravelAnalysisMessages.groupRoutine]: "Rutina de planta y despacho",
  [TravelAnalysisMessages.groupRoutineDesc]: "Maniobra justo después de salir de la planta, o nota cambiada o sustituida.",
  [TravelAnalysisMessages.groupOthers]: "Otros",
  [TravelAnalysisMessages.groupOthersDesc]: "Estados registrados que no llegaron a la integración y casos sin patrón.",
  [TravelAnalysisMessages.outcomeComplete]: "Ciclo completo",
  [TravelAnalysisMessages.outcomeSensorStopped]: "Sensor de descarga detenido",
  [TravelAnalysisMessages.outcomeSensorStoppedDesc]: "El camión llegó a la obra, pero el sensor casi nunca registra la descarga.",
  [TravelAnalysisMessages.outcomeSensorStoppedAction]: "Mantenimiento del sensor",
  [TravelAnalysisMessages.outcomeSensorIntermittent]: "Sensor de descarga intermitente",
  [TravelAnalysisMessages.outcomeSensorIntermittentDesc]: "El sensor registra la descarga en parte de los viajes y falla en los demás.",
  [TravelAnalysisMessages.outcomeSensorIntermittentAction]: "Revisar el sensor y el cable",
  [TravelAnalysisMessages.outcomeDischargeOneOff]: "Descarga no registrada (puntual)",
  [TravelAnalysisMessages.outcomeDischargeOneOffDesc]: "Camión con el sensor en buen estado que, en un viaje aislado, no registró la descarga.",
  [TravelAnalysisMessages.outcomeDischargeOneOffAction]: "Acompañar",
  [TravelAnalysisMessages.outcomeTrackerWithoutSignal]: "Rastreador sin señal",
  [TravelAnalysisMessages.outcomeTrackerWithoutSignalDesc]: "El rastreador no transmitió durante el viaje.",
  [TravelAnalysisMessages.outcomeTrackerWithoutSignalAction]: "Mantenimiento del rastreador",
  [TravelAnalysisMessages.outcomeInactivePlant]: "Planta inactiva en el registro",
  [TravelAnalysisMessages.outcomeInactivePlantDesc]: "La planta de origen está inactiva: el camión no es reconocido en ella y el viaje no empieza.",
  [TravelAnalysisMessages.outcomeInactivePlantAction]: "Reactivar la planta en Registro › Ubicaciones",
  [TravelAnalysisMessages.outcomeJobsiteNotDetected]: "Llegada a la obra no detectada",
  [TravelAnalysisMessages.outcomeJobsiteNotDetectedDesc]: "El camión salió de la planta, pero no fue reconocido dentro de la obra.",
  [TravelAnalysisMessages.outcomeJobsiteNotDetectedAction]: "Ajustar la ubicación de la obra",
  [TravelAnalysisMessages.outcomeDischargeOutsideJobsite]: "Descarga fuera del área de la obra",
  [TravelAnalysisMessages.outcomeDischargeOutsideJobsiteDesc]: "El sensor registró la descarga fuera del área registrada de la obra.",
  [TravelAnalysisMessages.outcomeDischargeOutsideJobsiteAction]: "Ajustar la ubicación de la obra desde la alerta",
  [TravelAnalysisMessages.outcomeJobsiteNextToPlant]: "Obra junto a la planta",
  [TravelAnalysisMessages.outcomeJobsiteNextToPlantDesc]: "La obra está a menos de 500 m de la planta: el camión no sale del área de la planta y el viaje no empieza.",
  [TravelAnalysisMessages.outcomeJobsiteNextToPlantAction]: "Revisar las áreas de la planta y de la obra",
  [TravelAnalysisMessages.outcomeShortPlantExit]: "Salida corta de la planta",
  [TravelAnalysisMessages.outcomeShortPlantExitDesc]: "Salió y volvió a la planta en hasta 10 minutos, en una maniobra o pesaje, y eso cerró el viaje antes de la entrega.",
  [TravelAnalysisMessages.outcomeShortPlantExitAction]: "Maniobra y pesaje dentro del área de la planta",
  [TravelAnalysisMessages.outcomeReplacedTicket]: "Nota sustituida por otra",
  [TravelAnalysisMessages.outcomeReplacedTicketDesc]: "El camión hizo otra nota y esta no empezó: fue cancelada por la siguiente o quedó en la cola.",
  [TravelAnalysisMessages.outcomeReplacedTicketAction]: "Revisar el orden de las notas",
  [TravelAnalysisMessages.outcomeTwoTickets]: "Dos notas en el mismo camión",
  [TravelAnalysisMessages.outcomeTwoTicketsDesc]: "Dos notas para el mismo camión con menos de 15 minutos entre ellas: solo la última sigue.",
  [TravelAnalysisMessages.outcomeTwoTicketsAction]: "Una nota por carga",
  [TravelAnalysisMessages.outcomeIntegrationNotSent]: "Estado no enviado a la integración",
  [TravelAnalysisMessages.outcomeIntegrationNotSentDesc]: "Los 5 estados fueron registrados, pero alguno no fue enviado a la integración.",
  [TravelAnalysisMessages.outcomeIntegrationNotSentAction]: "Revisar el log de la integración",
  [TravelAnalysisMessages.outcomeOther]: "Sin patrón identificado",
  [TravelAnalysisMessages.outcomeOtherDesc]: "La secuencia de estados no encaja en las causas anteriores.",
  [TravelAnalysisMessages.outcomeOtherAction]: "Analizar el viaje",
  [TravelAnalysisMessages.cyclePlacesByRegional]: "Ciclo completo por Regional",
  [TravelAnalysisMessages.cyclePlacesByPlant]: "Ciclo completo por Planta",
  [TravelAnalysisMessages.cyclePlacesHint]: "Haga clic en el nombre para filtrar la pantalla por él.",
  [TravelAnalysisMessages.toggleRegional]: "Regional",
  [TravelAnalysisMessages.togglePlant]: "Planta",
  [TravelAnalysisMessages.toggleTable]: "Tabla",
  [TravelAnalysisMessages.toggleChart]: "Gráfico",
  [TravelAnalysisMessages.columnRegional]: "Regional",
  [TravelAnalysisMessages.columnPlant]: "Planta",
  [TravelAnalysisMessages.columnTravels]: "Viajes",
  [TravelAnalysisMessages.columnCycleComplete]: "Ciclo completo",
  [TravelAnalysisMessages.columnFailuresByType]: "Fallas por tipo",
  [TravelAnalysisMessages.columnTopCause]: "Causa principal",
  [TravelAnalysisMessages.fewTravels]: "pocos viajes",
  [TravelAnalysisMessages.ofTravels]: "de los viajes",
  [TravelAnalysisMessages.noRegional]: "Sin regional",
  [TravelAnalysisMessages.hardwareTitle]: "Hardware a verificar",
  [TravelAnalysisMessages.hardwareHint]: "Vehículos cuyo sensor de descarga o rastreador hizo fallar viajes en el período. El botón de la fila muestra los viajes.",
  [TravelAnalysisMessages.hwAll]: "Todos",
  [TravelAnalysisMessages.hwSensorStopped]: "Sensor detenido",
  [TravelAnalysisMessages.hwSensorIntermittent]: "Sensor intermitente",
  [TravelAnalysisMessages.hwTracker]: "Rastreador sin señal",
  [TravelAnalysisMessages.columnProblem]: "Problema",
  [TravelAnalysisMessages.columnDischarges]: "Descargas registradas",
  [TravelAnalysisMessages.columnFailedTravels]: "Viajes con falla",
  [TravelAnalysisMessages.columnLastUnload]: "Última descarga",
  [TravelAnalysisMessages.columnLastSignal]: "Última señal",
  [TravelAnalysisMessages.wordOf]: "de",
  [TravelAnalysisMessages.hwSensorShort]: "sensor",
  [TravelAnalysisMessages.hwTrackerShort]: "rastreador",
  [TravelAnalysisMessages.noHardware]: "Ningún hardware a verificar en el filtro",
  [TravelAnalysisMessages.cycleDrilldownTitle]: "Detalle de Fallas",
  [TravelAnalysisMessages.columnMainPlant]: "Planta principal",
  [TravelAnalysisMessages.columnTravelsWithCause]: "Viajes con esta causa",
  [TravelAnalysisMessages.columnShareOfVehicle]: "% de los viajes del vehículo",
  [TravelAnalysisMessages.columnRegisteredStates]: "Estados registrados",
  [TravelAnalysisMessages.columnCause]: "Causa",
  [TravelAnalysisMessages.stateRegistered]: "registrado",
  [TravelAnalysisMessages.stateNotRegistered]: "no registrado",
  [TravelAnalysisMessages.telemetryTitle]: "Alertas de telemetría",
  [TravelAnalysisMessages.telemetryHint]: "Avisos sobre la calidad de los datos del rastreador y de los sensores. No cuentan en el ciclo completo.",
  [TravelAnalysisMessages.glossaryCyclesSection]: "Causas de falla del ciclo",
  [TravelAnalysisMessages.glossaryAlertsSection]: "Alertas de telemetría",
  [TravelAnalysisMessages.glossaryWhatToDo]: "Qué hacer",
  [TravelAnalysisMessages.glossarySensorHealth]: "Sensor detenido: registró la descarga en menos del 10% de los viajes que llegaron a la obra en el período. Intermitente: entre 10% y 80%. Con menos de 5 viajes en la obra, cuenta como detenido cuando no registra descarga hace más de 14 días.",
  [TravelAnalysisMessages.dailyTitle]: "Ciclo completo por día",
  [TravelAnalysisMessages.dailyHint]: "Solo días con viajes. La línea punteada verde es el promedio del período y la discontinua gris muestra la tendencia de los últimos 5 días.",
  [TravelAnalysisMessages.movingAverage]: "Media móvil de 5 días",
  [TravelAnalysisMessages.periodAverage]: "Promedio del período",
  [TravelAnalysisMessages.averageShort]: "promedio",
  [TravelAnalysisMessages.generalLine]: "General",
  [TravelAnalysisMessages.selectedPlaces]: "{{count}} seleccionadas",
  [TravelAnalysisMessages.chartNotePlaces]: "Elija una o varias en el selector. La línea General suma todas y la punteada verde es el promedio del período. Los días con menos de 5 viajes quedan fuera de la línea.",
  [TravelAnalysisMessages.backTo]: "Volver a {{name}}",
  [TravelAnalysisMessages.tileTravels]: "Viajes",
  [TravelAnalysisMessages.tileShareOfFilter]: "De los viajes del filtro",
  [TravelAnalysisMessages.tileVehicles]: "Vehículos",
  [TravelAnalysisMessages.tileGroup]: "Grupo",
  [TravelAnalysisMessages.whatItIs]: "Qué es",
  [TravelAnalysisMessages.byRegional]: "Por regional",
  [TravelAnalysisMessages.byPlant]: "Por planta",
  [TravelAnalysisMessages.vehiclesWithCause]: "Vehículos con esta causa ({{count}})",
  [TravelAnalysisMessages.tileTravelsInPeriod]: "Viajes en el período",
  [TravelAnalysisMessages.tileWithFailure]: "Con falla",
  [TravelAnalysisMessages.tileWithThisCause]: "Con esta causa",
  [TravelAnalysisMessages.tilePlant]: "Planta",
  [TravelAnalysisMessages.tileSensor]: "Sensor de descarga",
  [TravelAnalysisMessages.sensorStopped]: "Detenido",
  [TravelAnalysisMessages.sensorIntermittent]: "Intermitente",
  [TravelAnalysisMessages.sensorOk]: "Funcionando",
  [TravelAnalysisMessages.sensorDetail]: "descarga en {{pct}} de {{reached}} viajes en la obra · última {{date}}",
  [TravelAnalysisMessages.failuresByCause]: "Fallas por causa",
  [TravelAnalysisMessages.failedTravelsCount]: "Viajes con falla ({{count}})",
  [TravelAnalysisMessages.columnDetails]: "Detalles",
  [TravelAnalysisMessages.stateOnTheWay]: "En camino",
  [TravelAnalysisMessages.stateJobsite]: "En obra",
  [TravelAnalysisMessages.stateDischarging]: "Descargando",
  [TravelAnalysisMessages.stateReturning]: "Retornando",
  [TravelAnalysisMessages.statePlant]: "En planta",
  [TravelAnalysisMessages.glossaryCausesCount]: "{{count}} causas",
  [TravelAnalysisMessages.glossaryAlertsCount]: "{{count}} alertas"
};
